import { jsxs, jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Text, token } from "@zillow/constellation";
import { getWholeDollars } from "../../../utils/zhl-calculator.esm.js";
const StyledBudgetStretchedDescription = styled.span.withConfig({
  displayName: "AffordabilityDescription__StyledBudgetStretchedDescription",
  componentId: "sc-1y9fnn5-0"
})(["color:", ";"], token("colors.caution"));
const StyledBudgetComfortableDescription = styled.span.withConfig({
  displayName: "AffordabilityDescription__StyledBudgetComfortableDescription",
  componentId: "sc-1y9fnn5-1"
})(["color:", ";"], token("colors.green500"));
const StyledDescription = styled.div.withConfig({
  displayName: "AffordabilityDescription__StyledDescription",
  componentId: "sc-1y9fnn5-2"
})(["text-align:center;"]);
const LiveRegion = styled(Text).attrs({
  "aria-live": "polite",
  "aria-atomic": "true",
  "fontType": "h5"
}).withConfig({
  displayName: "AffordabilityDescription__LiveRegion",
  componentId: "sc-1y9fnn5-3"
})([""]);
const HomeValue = styled(Text).attrs({
  fontType: "h3"
}).withConfig({
  displayName: "AffordabilityDescription__HomeValue",
  componentId: "sc-1y9fnn5-4"
})(["display:block;"]);
const AffordabilityDescription = ({
  aggressive,
  customPayment,
  affordabilityByDTI
}) => /* @__PURE__ */ jsxs(StyledDescription, { children: [
  /* @__PURE__ */ jsxs(LiveRegion, { children: [
    "You can afford a house up to",
    /* @__PURE__ */ jsx(HomeValue, { children: getWholeDollars(affordabilityByDTI) })
  ] }),
  /* @__PURE__ */ jsxs(Text, { fontType: "body", children: [
    customPayment && /* @__PURE__ */ jsx(React.Fragment, { children: "A house at this price would keep you within your monthly payment budget. You could afford more with a bigger down payment." }),
    aggressive && /* @__PURE__ */ jsxs(React.Fragment, { children: [
      "Based on your income, a house at this price",
      /* @__PURE__ */ jsx("br", {}),
      "may",
      " ",
      /* @__PURE__ */ jsx(StyledBudgetStretchedDescription, { children: "stretch your budget" }),
      " ",
      "too thin."
    ] }),
    !customPayment && !aggressive && /* @__PURE__ */ jsxs(React.Fragment, { children: [
      "Based on your income, a house at this price",
      /* @__PURE__ */ jsx("br", {}),
      "should",
      " ",
      /* @__PURE__ */ jsx(StyledBudgetComfortableDescription, { children: "fit comfortably" }),
      " ",
      "within your budget."
    ] })
  ] })
] });
AffordabilityDescription.propTypes = {
  aggressive: PropTypes.bool,
  customPayment: PropTypes.bool,
  affordabilityByDTI: PropTypes.number
};
export {
  AffordabilityDescription as default
};
